<template>
  <EntityEditCard :title="$t('servicesystem.common_objects.service_agreement.deafault_details')" :item="editObject"
    :overrideCopyItem="machineType.ServiceAgreement" :saveMethod="saveChanges"
    :deleteMethod="machineType.ServiceAgreement ? deleteAgreement : undefined">
    <template v-slot:content="{ item, editMode, handleFocus }">
      <v-container v-if="noDetailsSpecifiedOnType && !editMode">
        {{ $t('servicesystem.common_objects.service_agreement.no_details_specified') }}
      </v-container>
      <v-container v-else fluid>
        <v-row>
          <v-col cols="6">
            <QTextField v-model="item.NumberOfTechnicianRequired"
              :label="$t('servicesystem.common_objects.service_agreement.number_of_technicians')"
              :externaledit="editMode" :rules="[requiredRule, intRule]" @FocusState="handleFocus">
            </QTextField>
          </v-col>
          <v-col cols="6">
            <QTextField v-model="item.HoursOfWorkEachTechnician"
              :label="$t('servicesystem.common_objects.service_agreement.hours')" :externaledit="editMode"
              :rules="[requiredRule, floatRule]" @FocusState="handleFocus">
            </QTextField>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0">
            {{ $t('servicesystem.common_objects.service_agreement.repeat_every') }}*
          </v-col>
          <v-col cols="3" class="pt-0">
            <QTextField v-model="item.ReoccuranceRepeat" singleline
              :label="$t('servicesystem.common_objects.commonterms.multiplier')" :externaledit="editMode"
              :rules="[requiredRule, intRule]" @FocusState="handleFocus">
            </QTextField>
          </v-col>
          <v-col cols="3" class="pt-0">
            <QAutoComplete v-model="item.ReoccuranceHowOften" singleline
              :label="$t('servicesystem.common_objects.commonterms.unit')"
              :list="getReoccuranceHowOftenOptions(item.ReoccuranceRepeat)" :textkey="'text'" :valuekey="'value'"
              :rules="[requiredRule]" :externaledit="editMode" @FocusState="handleFocus">
            </QAutoComplete>
          </v-col>
        </v-row>
        <!-- THESE DONT MAKE SENSE FOR MACHINE TYPE LEVEL SERVICE AGREEMENTS
        <v-row>
          <v-col cols="12">
            <QTextField v-model="item.ReocurrencyDayOffset" :label="$t('servicesystem.common_objects.service_agreement.start_day_offset')"
              :externaledit="editMode" @FocusState="handleFocus">
            </QTextField>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <QTextField v-model="item.ReocurrencyStartDate" :label="$t('servicesystem.common_objects.service_agreement.start_date')"
              :externaledit="editMode" @FocusState="handleFocus">
            </QTextField>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <QTextField v-model="item.ReocurrencyEndDate" :label="$t('servicesystem.common_objects.service_agreement.end_date')"
              :externaledit="editMode" @FocusState="handleFocus">
            </QTextField>
          </v-col>
        </v-row>
        -->
        <v-row>
          <v-col cols="12">
            <QCheckboxInput v-model="item.ServiceFromInstallationDate"
              :label="$t('servicesystem.common_objects.service_agreement.from_install_date')" :externaledit="editMode"
              @FocusState="handleFocus">
            </QCheckboxInput>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </EntityEditCard>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin";
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";

export default {
  name: "MachineTypeDefaultServiceAgreementDetails",
  props: {
    machineType: Object,
  },
  components: {
    EntityEditCard,
  },
  mixins: [clientAPI],

  data() {
    return {
      editObject: {},
    };
  },

  mounted() {
    this.parseObejct();
  },

  methods: {
    parseObejct() {
      //console.log('machineType', this.machineType);
      //console.log('default', this.DefaultAgreementDetails);
      var value = this.noDetailsSpecifiedOnType ? this.DefaultAgreementDetails : this.machineType.ServiceAgreement;
      this.editObject = Object.assign(value);
    },

    async saveChanges(serviceAgreement) {
      var typeCopy = Object.assign({}, this.machineType);
      typeCopy.ServiceAgreement = serviceAgreement;
      const dto = Object.assign({}, typeCopy);
      await this.updateMachineType(dto)
        .then((response) => {
          this.$emit("Set", response);
        })
        .catch((exception) => {
          console.error(exception);
        });
    },

    async deleteAgreement() {
      //console.log('deleteAgreement');
      await this.deleteMachineTypeServiceAgreement(this.machineType.Id)
        .then((response) => {
          this.$emit("Set", response);
        })
        .catch((exception) => {
          console.error(exception);
        });
    },

    getReoccuranceHowOftenOptions(repeat) {
      var isPlural = repeat > 1;
      return [
        { value: 'Month', text: isPlural ? this.$t('servicesystem.common_objects.commonterms.months') : this.$t('servicesystem.common_objects.commonterms.month') },
        { value: 'Year', text: isPlural ? this.$t('servicesystem.common_objects.commonterms.years') : this.$t('servicesystem.common_objects.commonterms.year') },
      ]
    },
  },

  computed: {
    noDetailsSpecifiedOnType() {
      return this.machineType && !this.machineType.ServiceAgreement;
    },

    DefaultAgreementDetails() {
      return this.$store.state.GlobalSettings.DefaultServiceAgreementDetails;
    },
  },

  watch: {},
};
</script>


<style lang='scss'></style>